// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-subheader[data-v-e2b279e0]{display:flex;font-size:1.2rem;height:4rem;justify-content:space-between;margin-left:auto;margin-right:auto;max-width:1920px;padding:2rem 5rem;position:relative}.fill-white[data-v-e2b279e0]{fill:#fff}.nuxt-link-active .link-text[data-v-e2b279e0]{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
